/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './CrmVisualizationSettingsRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#createUserViewSettings
 */
export const CREATE_USER_VIEW_SETTINGS_MUTATION_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_createUserViewSettings';
export const CREATE_USER_VIEW_SETTINGS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_USER_VIEW_SETTINGS_MUTATION_FIELD_NAME,
  args: ['visualizationType', 'viewId', 'settings', 'objectTypeId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createUserViewSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#updateSettingsById
 */
export const UPDATE_SETTINGS_BY_ID_MUTATION_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_updateSettingsById';
export const UPDATE_SETTINGS_BY_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_SETTINGS_BY_ID_MUTATION_FIELD_NAME,
  args: ['id', 'settings', 'objectTypeId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updateSettingsByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#getEffectiveSettings
 */
export const GET_EFFECTIVE_SETTINGS_QUERY_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_getEffectiveSettings';
export const GET_EFFECTIVE_SETTINGS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_EFFECTIVE_SETTINGS_QUERY_FIELD_NAME,
  args: ['visualizationType', 'viewId', 'objectTypeId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getEffectiveSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#getEffectiveSettingsBatch
 */
export const GET_EFFECTIVE_SETTINGS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_getEffectiveSettingsBatch';
export const GET_EFFECTIVE_SETTINGS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_EFFECTIVE_SETTINGS_BATCH_QUERY_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getEffectiveSettingsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#upsertSettings
 */
export const UPSERT_SETTINGS_MUTATION_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_upsertSettings';
export const UPSERT_SETTINGS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_SETTINGS_MUTATION_FIELD_NAME,
  args: ['id', 'visualizationType', 'audienceType', 'targetType', 'target', 'settings', 'objectTypeId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.upsertSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#upsertUserViewSettings
 */
export const UPSERT_USER_VIEW_SETTINGS_MUTATION_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_upsertUserViewSettings';
export const UPSERT_USER_VIEW_SETTINGS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_USER_VIEW_SETTINGS_MUTATION_FIELD_NAME,
  args: ['id', 'visualizationType', 'viewId', 'settings', 'objectTypeId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.upsertUserViewSettingsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#upsertUserViewSettingsBatch
 */
export const UPSERT_USER_VIEW_SETTINGS_BATCH_MUTATION_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_upsertUserViewSettingsBatch';
export const UPSERT_USER_VIEW_SETTINGS_BATCH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_USER_VIEW_SETTINGS_BATCH_MUTATION_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.upsertUserViewSettingsBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#deleteSettingsById
 */
export const DELETE_SETTINGS_BY_ID_MUTATION_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_deleteSettingsById';
export const DELETE_SETTINGS_BY_ID_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_SETTINGS_BY_ID_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.deleteSettingsByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.crm.visualization.settings.rpc.CrmVisualizationSettingsRpc#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME = 'com_hubspot_crm_visualization_settings_rpc_CrmVisualizationSettingsRpc_getById';
export const GET_BY_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});